import * as types from "./bentukKerjasama.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { BentukKerjasama } from "../../interfaces/BentukKerjasama";
import { BentukKerjasamaCreateResponse, BentukKerjasamaListResponse, BentukKerjasamaUpdateResponse } from "./types";

export const selectBentukKerjasama = (bentukKerjasama: BentukKerjasama | null) => action(types.SELECT_BENTUK_KERJASAMA, { bentukKerjasama });

export const updateName = (name: string) => action(types.UPDATE_NAME, { name });

export const updateStatus = (status: number) => action(types.UPDATE_STATUS, { status });

export const initializeCreateBentukKerjasama = () => {
  const bentukKerjasama: BentukKerjasama | null = {
    KERMA_ID: 0,
    NAMA: '',
    STATUS: 0
  }

  return action(types.INITIALIZE_CREATE_BENTUK_KERJASAMA, { bentukKerjasama })
}

export const getBentukKerjasamaAsync = createAsyncAction(
  types.GET_BENTUK_KERJASAMA_REQUEST,
  types.GET_BENTUK_KERJASAMA_SUCCESS,
  types.GET_BENTUK_KERJASAMA_FAILURE
)<{ status?: number }, BentukKerjasamaListResponse, ErrorResponse>();

export const getDetailBentukKerjasamaAsync = createAsyncAction(
  types.GET_DETAIL_BENTUK_KERJASAMA_REQUEST,
  types.GET_DETAIL_BENTUK_KERJASAMA_SUCCESS,
  types.GET_DETAIL_BENTUK_KERJASAMA_FAILURE
)<{ id: number }, BentukKerjasama, ErrorResponse>();

export const updateBentukKerjasamaAsync = createAsyncAction(
  types.UPDATE_BENTUK_KERJASAMA_REQUEST,
  types.UPDATE_BENTUK_KERJASAMA_SUCCESS,
  types.UPDATE_BENTUK_KERJASAMA_FAILURE
)<BentukKerjasama, BentukKerjasamaUpdateResponse, ErrorResponse>();

export const createBentukKerjasamaAsync = createAsyncAction(
  types.CREATE_BENTUK_KERJASAMA_REQUEST,
  types.CREATE_BENTUK_KERJASAMA_SUCCESS,
  types.CREATE_BENTUK_KERJASAMA_FAILURE
)<BentukKerjasama, BentukKerjasamaCreateResponse, ErrorResponse>();
